import { Component, Input } from '@angular/core';
import { NgProgress } from '@ngx-progressbar/core';
import { ToastrService } from 'ngx-toastr';
import { APIOperableComponent } from '../../../../shared/components/api-operable/api-operable.component';
import { LinkedItemsListManageDialogComponent } from '../../../../shared/components/linked-items-list-manage-dialog/linked-items-list-manage-dialog.component';
import { UIDialogService } from '../../../../shared/services/ui-dialog.service';
import { AuthService } from '../../../security/service/auth.service';
import { PartsCustomerSuppliedColumnsModel } from '../../model/parts-customer-supplied-columns.model';
import { PartsUIMessages } from '../../model/parts-ui.message';
import { PartsService } from '../../service/parts.service';

@Component({
  selector: 'app-parts-customer-supplied',
  templateUrl:
    './console/app-js/modules/parts/components/parts-customer-supplied/parts-customer-supplied.component.html'
})
export class PartsCustomerSuppliedComponent extends APIOperableComponent {
  @Input('partId') partId: string;
  public canManageParts = false;
  public customerSuppliedParts = [];
  public customerSuppliedPartsInactive = [];
  public customerSuppliedPartsColumns = PartsCustomerSuppliedColumnsModel;
  public loading = false;
  public noRecordsSettings = {
    message: 'No data to display',
    styleClass: 'no-records-wrapper'
  };

  constructor(
    toastr: ToastrService,
    progressService: NgProgress,
    authService: AuthService,
    public partsService: PartsService,
    private dialogService: UIDialogService
  ) {
    super(progressService, toastr, authService);
  }

  ngOnInit() {
    // VL-2482: Admin Portal part management actions are disabled.
    this.canManageParts = false;
    this.getCustomerSuppliedParts(this.partId);
  }

  private getCustomerSuppliedParts(partId: string) {
    this.progressRef.start();
    this.loading = true;
    this.partsService.getCustomerSuppliedParts(partId).subscribe(
      res => {
        if (res.length) {
          this.partsService.getAllCustomerNames(res).subscribe(
            (customers: any) => {
              res.map((customer: any) => {
                customer.name = customers.filter(
                  (item: any) => item.number === customer.customerNumber
                )[0].name;
                customer.number = customer.customerNumber;
              });
              this.customerSuppliedParts = res.filter(
                customer => customer.isActive
              );
              this.customerSuppliedPartsInactive = res.filter(
                customer => !customer.isActive
              );
              this.loading = false;
              this.progressRef.complete();
            },
            () => {
              this.loading = false;
              this.progressRef.complete();
            }
          );
        } else {
          this.loading = false;
          this.progressRef.complete();
        }
      },
      () => {
        this.loading = false;
        this.progressRef.complete();
      }
    );
  }

  public onManage() {
    if (!this.canManageParts) {
      return;
    }
    this.dialogService
      .open(LinkedItemsListManageDialogComponent, [
        {
          provide: Array,
          useValue: this.customerSuppliedParts
        },
        {
          provide: Function,
          useValue: this.partsService.getCustomers
        },
        {
          provide: 'allItems',
          useValue: null
        },
        {
          provide: 'title',
          useValue: 'Customer Supplier'
        },
        {
          provide: 'property',
          useValue: 'number'
        },
        {
          provide: 'idField',
          useValue: 'number'
        }
      ])
      .then(results => {
        this.progressRef.start();
        this.loading = true;
        // contains all added lines of service
        const newCustomers = results.filter(
          customer =>
            !this.customerSuppliedParts.find(c => customer.number === c.number)
        );
        // contains lines of service that were removed - call PUT isActive = false
        const deletedCustomers = this.customerSuppliedParts.filter(
          customer => !results.find(c => customer.number === c.number)
        );
        // contains added lines of service with previous relationship = call PUT isActive = true
        const newCustomersPut = newCustomers.filter(customer =>
          this.customerSuppliedPartsInactive.find(
            c => customer.number === c.number
          )
        );
        // contains added lines of service without previous relationship = call POST
        const newCustomersPost = newCustomers.filter(
          customer =>
            !this.customerSuppliedPartsInactive.find(
              c => customer.number === c.number
            )
        );
        this.partsService
          .updateCustomerParts(
            newCustomersPut,
            newCustomersPost,
            deletedCustomers,
            this.partId
          )
          .subscribe(
            (res: any) => {
              if (res) {
                this.customerSuppliedParts = [];
                this.toastr.success(PartsUIMessages.UPDATE_CUSTOMER_SUCCESS);
                this.getCustomerSuppliedParts(this.partId);
              } else {
                this.toastr.error(PartsUIMessages.UPDATE_CUSTOMER_ERROR);
              }
            },
            error => {
              this.toastr.error(error.errorMessage);
              this.progressRef.complete();
              this.loading = false;
            }
          );
      })
      .catch(error => {
        if (error) {
          console.log(error);
        }
        // on popup Cancel button, do nothing by the moment.
      });
  }
}
